import { render, staticRenderFns } from "./EventDisplayMenu.vue?vue&type=template&id=0d1405d0"
import script from "./EventDisplayMenu.vue?vue&type=script&lang=js"
export * from "./EventDisplayMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports